if (window.innerWidth < 1200) {
  const swiperBenefit = new Swiper(".swiper-benefit", {
    // Optional parameters
    loop: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,

    // If we need pagination
    pagination: {
      el: ".swiper-dots",
    },

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },
  });
}
